import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgram/AddressProgramOrderApi";
import store from "../../../../Frontends/Common/store";
import i18n from "../../../../Frontends/Common/utils/i18n";

export class AddressProgramOrderService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
    this.data = []
    this.hasAdjustmentFilterTypes = [
      { text: i18n.global.t("yes"), value: true },
      { text: i18n.global.t("no"), value: false }
    ];
  }
  setGroups(groups) {
    this.data = groups
  }
  getGroups() {
    return this.data
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editAddressProgramOrder", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editAddressProgramOrder");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getAddressProgramOrders", args, this.data);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getAddressProgramOrder", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createAddressProgramOrder", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteAddressProgramOrder", model);
  }
  async update(model) {
    let updateMethod = "";
    let role = JSON.parse(localStorage.getItem("userRole")).systemName;

    if(role === 'Administrator' || role === 'COAdministrator')
      updateMethod = "updateAddressProgramOrderCoAdmin"
    else if(role === 'COSupervisor')
      updateMethod = "updateAddressProgramOrderCoSupervisor"
    else
      updateMethod = "updateAddressProgramOrderAgency"

    return await this.transformer.editItem(this.Api, updateMethod, model);
  }
  async import(gfid, marsPeriod) {
    const res = this.Api.import(gfid, marsPeriod);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async importKPIPlan(gfid, marsPeriod) {
    const res = this.Api.importKPIPlan(gfid, marsPeriod);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async importKPIFact(gfid, marsPeriod) {
    const res = this.Api.importKPIFact(gfid, marsPeriod);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async importBudgetFact(gfid, marsPeriod) {
    const res = this.Api.importBudgetFact(gfid, marsPeriod);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async importAgencyTerritory(gfid, marsPeriod) {
    const res = this.Api.importAgencyTerritory(gfid, marsPeriod);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold("addressprogramorder");
  }
  async getKPIPlanImportScaffold() {
    return await this.Api.getImportScaffold("addressprogramorderkpiplan");
  }
  async getKPIFactImportScaffold() {
    return await this.Api.getImportScaffold("addressprogramorderkpifact");
  }
  async getBudgetFactImportScaffold() {
    return await this.Api.getImportScaffold("addressprogramorderbudgetfact");
  }
  async getAgencyTerritoryImportScaffold() {
    return await this.Api.getImportScaffold("addressprogramorderagencyterritory");
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async copyAgencyTerritory(marsPeriod) {
    return await this.Api.copyAgencyTerritory(marsPeriod);
  }
  async updateMultipleAddressProgramOrderAgency(model) {
    await this.transformer.editItem(this.Api, "updateMultipleAddressProgramOrderAgency", model);
  }
  async gethasAdjustmentFilterTypes() {
    return Promise.resolve({ data: { records: this.hasAdjustmentFilterTypes } });
  }
}
